import { ApiErrorCodeLabelModifier } from '@/api/error-codes';
import { Box, Loading } from '@/components';
import { useMessage } from '@/providers';
import { AxiosError } from 'axios';
import type { FC, PropsWithChildren } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router';

import { useMe } from '../_hooks/me';

export const AuthenticatedGuard: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const me = useMe();
  const [cookies] = useCookies();
  const { openMessage } = useMessage();
  const accessToken = cookies.access_token;
  const location = useLocation();

  if (me.isError || !accessToken) {
    const message =
      me.error instanceof AxiosError
        ? (ApiErrorCodeLabelModifier[me.error.response?.data.error_code] ??
          t('logout-forcibly'))
        : t('logout-forcibly');

    openMessage('warning', message);
    const redirect = encodeURIComponent(
      `${location.pathname}${location.search}`,
    );
    return <Navigate replace to={`/login?redirectUri=${redirect}`} />;
  }

  if (me.isLoading) {
    return (
      <Box height="100vh">
        <Loading />
      </Box>
    );
  }

  return <>{children}</>;
};
